import anime from 'animejs';
import Medusa from '@adoratorio/medusa';
import engine from '@/scripts/engine';
import { isMobile } from '@/scripts/utils';

function clamp(v, min = 0, max = 1) {
  return Math.min(max, Math.max(min, v));
}

function invlerp(a, b, v) {
  return clamp((v - a) / (b - a));
}

function animationText(el) {
  return anime({
    targets: el,
    translateY: isMobile() ? [100, -80] : [160, -120],
    easing: 'linear',
    duration: 100,
    autoplay: false,
  });
}

export default {
  id: 'parallaxText',
  nodes: [],
  container: document.getElementById('app'),
  threshold: Medusa.THRESHOLD.BEARLY,
  offsets: '30px 0px 30px 0px',
  emitGlobal: false,
  callback: ({ isIntersecting, target }) => {
    if (isIntersecting) {
      const { height } = target.getBoundingClientRect();

      // eslint-disable-next-line max-len
      const scroll = offsetTop => invlerp(-window.innerHeight, height, -offsetTop);

      const parallaxText = animationText(target);

      engine.add(() => {
        parallaxText.seek(scroll(target.getBoundingClientRect().top) * 100);
      }, target);
    } else {
      engine.remove(target);
    }
  },
  mode: Medusa.MODE.DEFAULT,
};
